'use client';
import React from 'react';
import Link from 'next/link';
import { motion } from 'framer-motion';

const IndustriesSection = () => {
  const industriesData = [
    {
      image: '/images/industries/food_beverage.png',
      title: 'Food and Beverage',
      link: '/industries/food-and-beverage',
      fit: 'cover',
      tag: 'Premium Solutions'
    },
    {
      image: '/images/industries/pharma.jpg',
      title: 'Pharmaceuticals',
      link: '/industries/pharma',
      fit: 'cover',
      tag: 'High Compliance'
    },
    {
      image: '/images/industries/dairy.png',
      title: 'Dairy Products',
      link: '/industries/dairy',
      fit: 'cover',
      tag: 'Moisture Resistant'
    },
    {
      image: '/images/industries/liquor.png',
      title: 'Liquor and Alcohol',
      link: '/industries/liquor-alcohol',
      fit: 'cover',
      tag: 'Texture & Foils'
    },
    {
      image: '/images/industries/cosmetics.png',
      title: 'Cosmetics & Care',
      link: '/industries/cosmetics',
      fit: 'cover',
      tag: 'Luxury Aesthetic'
    },
    {
      image: '/images/industries/oil.png',
      title: 'Oils and Lubricants',
      link: '/industries/oils-and-lubricants',
      fit: 'cover',
      tag: 'Industrial Strength'
    },
    {
      image: '/images/industries/home_care.jpg',
      title: 'Home Care',
      link: '/industries/home-care',
      fit: 'cover',
      tag: 'Durable Finish'
    },
    {
      image: '/images/industries/kitchen.jpg',
      title: 'Kitchen Products',
      link: '/industries/kitchen-products',
      fit: 'cover',
      tag: 'Heat Resistant'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  return (
    <section className="section-shell w-full bg-white !py-[80px] sm:!py-[120px]">
      <div className="container-fluid">
        <div className="flex flex-col items-center gap-fluid-xl">

          <motion.div
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center max-w-[800px]"
          >
            <span className="text-blue-600 font-bold tracking-[4px] uppercase text-xs mb-4 block">Specialized Expertise</span>
            <h2 className="type-section text-[#0a1f33] mb-6">
              Industries We <span className="italic font-serif">Serve</span>
            </h2>
            <p className="type-body text-slate-500 text-lg">
              Delivering high-performance, industry-specific labeling solutions that meet the most rigorous technical standards across global sectors.
            </p>
          </motion.div>

          {/* Industries Grid */}
          <motion.div
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-10 w-full"
          >
            {industriesData.map((industry, index) => (
              <motion.div
                key={index}
                variants={itemVariants}
                className="group flex flex-col items-start w-full"
              >
                <Link
                  href={industry.link}
                  className="no-tap-enforce relative w-full aspect-square rounded-[24px] overflow-hidden bg-slate-50 border border-slate-100 shadow-[0px_20px_40px_rgba(0,0,0,0.05)] transition-all duration-500 group-hover:shadow-[0px_30px_60px_rgba(0,0,0,0.1)] group-hover:-translate-y-2 block"
                >
                  {/* Relative wrapper + absolute fill for correct image responsiveness */}
                  <img
                    src={industry?.image}
                    alt={industry?.title}
                    className="absolute inset-0 w-full h-full transform transition-transform duration-700 group-hover:scale-110 object-cover"
                  />
                </Link>

                <div className="flex flex-col items-start w-full pt-6">
                  <h3 className="type-block text-left text-[#0a1f33] font-bold group-hover:text-blue-600 transition-colors duration-300">
                    {industry?.title}
                  </h3>
                  <div className="w-0 group-hover:w-full h-0.5 bg-blue-600 transition-all duration-500 mt-2"></div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;